import React from 'react';

export const InsuranceHealthInsurance = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='white' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.5 13.0001H9.5C8.67 13.0001 8 12.3301 8 11.5001C8 10.6701 8.67 10.0001 9.5 10.0001H10.5V9.00007C10.5 8.17007 11.17 7.50007 12 7.50007C12.83 7.50007 13.5 8.17007 13.5 9.00007V10.0001H14.5C15.33 10.0001 16 10.6701 16 11.5001C16 12.3301 15.33 13.0001 14.5 13.0001H13.5V14.0001C13.5 14.8301 12.83 15.5001 12 15.5001C11.17 15.5001 10.5 14.8301 10.5 14.0001V13.0001ZM11.3 2.26007L5.3 4.51007C4.52 4.81007 4 5.55007 4 6.39007V11.0901C4 16.1401 7.41 20.8501 12 22.0001C16.59 20.8501 20 16.1401 20 11.0901V6.39007C20 5.56007 19.48 4.81007 18.7 4.52007L12.7 2.27007C12.25 2.09007 11.75 2.09007 11.3 2.26007Z' />
    </svg>
  );
};
